import pkg from '../../../package.json';
import React, { useEffect, useState, useContext, useRef } from 'react';
import Navigation from '../../assets/images/Navigation-2.png';
import { useDispatch, useSelector } from 'react-redux';
import { resetlogInStatus, resetMsg } from '../../redux/reducers/Login';
// import {postLogIn, resetlogInStatus, resetMsg} from '../../redux/reducers/Login';
import PageLoader from '../../components/PageLoader';
import { ErrorSnackbar, SuccessSnackbar } from '../../components/CustomSnackBar';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { TextField, FormHelperText, InputAdornment, IconButton } from '@material-ui/core';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { resetFavoriteWindow } from '../../redux/reducers/FavouriteWindows';

import { cognitoServiceProvider } from '../../awsConfig';

function App() {
  const { expiryMsg, setSelectedTabs, setSelectedCMTabs, setCurrentSelectedTab } =
    useContext(SelectTabContextProvider);
  const history = useHistory();
  const dispatch = useDispatch();
  const { logInStatus, token, isLoading, errorMsg, successMsg, userid, expiryDate } = useSelector(
    ({ logIn }) => logIn,
  );
  const [passwordShown, setPasswordShown] = useState(false);
  const timer = useRef();
  const passwordExpireDate = expiryDate;
  const now = moment(new Date());
  const end = moment(passwordExpireDate);
  const days = now.diff(end, 'days');
  const initialValues = {
    userName: '',
    password: '',
  };
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
  };
  const [loginError, setLoginError] = useState('');
  const [isLoadingRequest, setIsLoadingRequest] = useState(false);

  useEffect(() => {
    if (logInStatus === 200 && days >= 0 && expiryDate) {
      setSelectedTabs([]);
      setSelectedCMTabs([]);
      sessionStorage.setItem('token', token);
      history.push('/change-password');
      dispatch(resetlogInStatus());
    } else if (logInStatus === 200) {
      setSelectedTabs([]);
      setSelectedCMTabs([]);
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('userId', userid);
      location?.state
        ? history.push(location?.state?.from.pathname)
        : history.push('/account-summary');
      dispatch(resetlogInStatus());
    }
  }, [logInStatus]);
  useEffect(() => {
    if (errorMsg) {
      timer.current = setTimeout(() => {
        dispatch(resetMsg());
      }, 10000);
    }
  }, [errorMsg]);
  useEffect(() => {
    setCurrentSelectedTab && setCurrentSelectedTab({});
    dispatch(resetFavoriteWindow());
    return () => {
      dispatch(resetMsg());
    };
  }, []);
  const validationSchema = Yup.object().shape({
    userName: Yup.string().required('Please enter your user name'),
    password: Yup.string().required('Please enter your password'),
  });
  const { handleSubmit, errors, register } = useForm({
    mode: 'onSubmit',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    setLoginError(null);
    setIsLoadingRequest(true); // Disable the login button to prevent multiple clicks

    if (data?.userName && data?.password) {
      const authParams = {
        AuthFlow: 'USER_PASSWORD_AUTH',
        ClientId: process.env.REACT_APP_COGNITO_ID || '', // Validate env variable
        AuthParameters: {
          USERNAME: data.userName.trim(),
          PASSWORD: data.password,
        },
      };

      try {
        const authResult = await cognitoServiceProvider.initiateAuth(authParams).promise();

        if (!authResult.AuthenticationResult) {
          throw new Error('Authentication failed: No authentication result.');
        }

        const userAttributes = await cognitoServiceProvider
          .getUser({
            AccessToken: authResult.AuthenticationResult.AccessToken,
          })
          .promise();

        // Store tokens in sessionStorage
        sessionStorage.setItem('refreshToken', authResult.AuthenticationResult.RefreshToken);
        sessionStorage.setItem('token', authResult.AuthenticationResult.IdToken);

        // Store user attributes
        const attributesMap = {
          'custom:roles': 'roleName',
          'custom:UserId': 'UserId',
          // 'custom:PortalId': 'PortalId',
          // 'custom:Clients': 'ClientsID',
        };

        userAttributes.UserAttributes.forEach((attribute) => {
          if (attributesMap[attribute.Name]) {
            sessionStorage.setItem(attributesMap[attribute.Name], attribute.Value);
          }

          // Handle roles separately
          if (attribute.Name === 'custom:roles') {
            const rolesIn = attribute.Value.split(',');
            sessionStorage.setItem('userRoles', JSON.stringify({ userRoles: rolesIn }));
          }
        });

        sessionStorage.setItem('xapikey', process.env.REACT_APP_API_KEY || '');

        // Redirect after successful login
        history.push('/account-summary');
      } catch (error) {
        setIsLoadingRequest(false);

        let errorMessage = 'An error occurred.';
        if (error.code === 'NotAuthorizedException') {
          errorMessage = error.message;
        } else if (error.code === 'UserNotFoundException') {
          errorMessage = 'User not found.';
        } else if (error.code === 'PasswordResetRequiredException') {
          errorMessage = 'Password reset is required.';
        } else {
          console.error('Error:', error);
        }
        setLoginError(errorMessage);
      }
    }

    setIsLoadingRequest(false); // Reset the loading state after success
  };

  return (
    <div className="App">
      <div className="login-page">
        <div className="main-content">
          <div className="company-logo">
            <img src={Navigation} alt="navigation-logo" />
          </div>
          <div className="form-content">
            <h4 role="heading" aria-level="1">
              Welcome!
            </h4>
            <h2>Please login using your credentials</h2>
            <form className="login-form" onSubmit={handleSubmit(onSubmit)} noValidate>
              <div className="form-group  reset-password-fields login-fields">
                <label className="titleForm">User Login Email</label>

                <TextField
                  type="text"
                  margin="dense"
                  variant="outlined"
                  className="form-control"
                  name="userName"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.userName?.message)}
                />

                <FormHelperText style={{ color: 'red' }}>
                  {errors.userName?.message ? errors.userName.message : ''}
                </FormHelperText>
              </div>
              <div className="form-group reset-password-fields login-fields password-fields">
                <label className="titleForm">Password</label>
                <TextField
                  type={passwordShown ? 'text' : 'password'}
                  margin="dense"
                  variant="outlined"
                  className="form-control"
                  name="password"
                  inputRef={register}
                  fullWidth
                  error={Boolean(errors.password?.message)}
                  InputProps={{
                    // <-- This is where the toggle button is added.
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="visible-icon"
                          aria-label="toggle password visibility"
                          onClick={togglePassword}
                        >
                          {passwordShown ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <FormHelperText style={{ color: 'red' }} variant="outlined">
                  {errors.password?.message ? errors.password.message : ''}
                </FormHelperText>
              </div>
              {loginError && <p style={{ color: 'red', textAlign: 'center' }}>{loginError}</p>}
              <button
                type="submit"
                disabled={isLoadingRequest}
                onClick={() => {
                  clearTimeout(timer?.current);
                  dispatch(resetMsg());
                }}
                className="login-btn btn-block mb-0"
              >
                Login
              </button>
              <div className="more-info">
                <div className="forgot-pw">
                  <Link
                    target="_blank"
                    to={{
                      pathname: `/forgot/index.html?api=${process.env.REACT_APP_API_END_POINT}/core/users/passreset&xkey=login_reset_ub2hNJbuM94VjYy61jKw4aot96xi6I7c7rU7FZ6C`,
                    }}
                  >
                    Forgot your password?
                  </Link>
                </div>
                <div className="reset">{/* <a href="/"></a> */}</div>
              </div>
              {/* <button type="button" className="signup-btn btn-block">
                CREATE AN ACCOUNT
              </button> */}
            </form>
          </div>
          <div className="copyright">
            <p style={{ color: '#FFFFFF' }}>&copy;2024 {pkg.version} RevOne Companies</p>
          </div>
        </div>
      </div>
      {isLoading && <PageLoader />}
      {(errorMsg || expiryMsg) && (
        <ErrorSnackbar errorMsg={errorMsg || expiryMsg} loginPage={true} />
      )}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
}

export default App;
